import Swiper, { Pagination, EffectFade, Navigation} from 'swiper';
Swiper.use([Pagination, EffectFade, Navigation]);

function initSwiper() {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    if (swiperContainers) {
        let sliders = [], 
            options = {};
        swiperContainers.forEach( (elem, i) => {
            sliders[i] = new Swiper(elem, {
                spaceBetween: 30,
                autoHeight: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                // centeredSlides: true,
                navigation: {
                    nextEl: elem.querySelector('.navigation__element--right'),
                    prevEl: elem.querySelector('.navigation__element--left'),
                  },
            });
            sliders[i].allowTouchMove = false;
            //console.log(sliders[i]);
        })
        
        return sliders;
    }

}

export default initSwiper;